import React from 'react';
import { Link, } from 'react-router-dom';

import SplitLogin from './SplitLogin/SplitLogin';
import { getLogoBySource } from '../../design-system/utils/getLogo';
import { userIsLoggedIn } from './Session/Session';
import { SOURCES } from '../../design-system/constants/sources';
import { ROOT_HOME } from '../../routes/paths';

// @material-ui/core
import { Typography, Box, IconButton, makeStyles } from '@material-ui/core';
import { Card, CardHeader, CardContent } from '@material-ui/core';
import clsx from 'clsx';
import { WHITE } from '../../design-system/constants/color-images';

const useStyles = makeStyles((theme) => ({
    page: {
        minHeight: '100vh',
        width: '100%',
        backgroundColor: theme.palette.colors.white,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
    root: {
        maxWidth: 600,
        width: '100%',
    },
    card: {
        [theme.breakpoints.down('xs')]: {
            marginTop: 60,
        },
        backgroundColor: `${theme.palette.colors.fillStroke[400]} !important`,
        border: `1px solid ${theme.palette.colors.fillStroke[200]}`,
        marginTop: 56,
        padding: '16px 80px !important',
    },
    cardHeader: {
        padding: "16px 20px 0 0"
    },
    cardContent: {
        padding: '16px 80px !important',
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {
            padding: '15px !important',
        }
    },
    headerActions: {
        width: '100%'
    },
    talisisLogo: {
        width: 120
    },
    closeIcon: {
        fontSize: '24px',
        color: theme.palette.colors.darkBlack[200]
    },
    closeIconButton: {
        padding: 0,
        float: 'right'
    },
}));

const Login = (props) => {
    const classes = useStyles();
    
    React.useEffect(() => {
        // Dependencia [] (no [props]): `props` es un objeto nuevo en cada render,
        // así que depender de él re-ejecutaba este efecto en bucle, disparando
        // history.push en cada render ("Too many attempts to navigate"). Solo
        // debe correr al montar. Usamos replace para no apilar historial.
        if (userIsLoggedIn()) {
            props.history.replace(ROOT_HOME);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box className={classes.page}>
            <Box className={classes.root}>
                <Card elevation={0} className={`${classes.card}`}>
                    <CardHeader className={classes.cardHeader}
                        action={
                            <IconButton className={classes.closeIconButton} component={Link} to={'/login'}>
                                <i className={clsx(classes.closeIcon, 'ri-close-line')} />
                            </IconButton>
                        }
                        classes={{ action: classes.headerActions }}
                    />
                    <CardContent className={classes.cardContent}>
                        <img src={getLogoBySource(SOURCES.TALISIS, WHITE)} className={classes.talisisLogo} alt="img-logo"/>
                        <Typography variant="body1" className="semi-bold mt-4" color="primary">Bienvenid@</Typography>
                        <Typography variant="body1" className={`semi-bold text-gray-100 mb-4`} align={'center'}>Portal Administrador Talisis</Typography>
                        <SplitLogin {...props} />
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default Login;
